/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Expand clickable area for Announcement Bar text blocks without nesting anchors
  function initAnnouncementBarClickZones() {
    try {
      var selector = '[data-section-type="announcement-bar"] .announcement__block--text';
      var blocks = document.querySelectorAll(selector);
      if (!blocks || blocks.length === 0) return;

      blocks.forEach(function(block) {
        // Avoid rebinding
        if (block.dataset.clickZoneBound === 'true') return;

        var links = Array.from(block.querySelectorAll('a[href]'));
        if (!links || links.length === 0) return;

        var primary = links[0];

        // Accessibility and affordance
        block.setAttribute('role', 'link');
        block.setAttribute('tabindex', '0');
        block.style.cursor = 'pointer';
        block.dataset.clickZoneBound = 'true';

        // Click anywhere in block -> follow primary link, unless actual anchor clicked
        block.addEventListener('click', function(e) {
          var target = e.target;
          var anchor = target && target.closest ? target.closest('a') : null;
          if (anchor && block.contains(anchor)) {
            // Respect native link clicks
            return;
          }

          // Redirect to primary link
          e.preventDefault();
          try {
            primary.click();
          } catch (err) {
            // Fallback
            var href = primary.getAttribute('href');
            var tgt = primary.getAttribute('target');
            if (tgt === '_blank') {
              var w = window.open(href, '_blank');
              if (w) w.opener = null;
            } else if (href) {
              window.location.href = href;
            }
          }
        });

        // Keyboard activation for accessibility
        block.addEventListener('keydown', function(e) {
          var active = document.activeElement;
          var insideAnchor = active && active.closest && active.closest('a') && block.contains(active.closest('a'));
          if (insideAnchor) return;
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            try {
              primary.click();
            } catch (err) {
              var href = primary.getAttribute('href');
              var tgt = primary.getAttribute('target');
              if (tgt === '_blank') {
                var w = window.open(href, '_blank');
                if (w) w.opener = null;
              } else if (href) {
                window.location.href = href;
              }
            }
          }
        });
      });
    } catch (e) {
      // Silent fail to avoid breaking other theme scripts
    }
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(initAnnouncementBarClickZones);
  document.addEventListener('shopify:section:load', initAnnouncementBarClickZones);

  class GiftPopupButton extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this.loading = false;
      this.hiddenUtilKey = 'gift-popup-closed-until';
      this.cartRefreshInFlight = null;
      this.cartRefreshQueued = false;
    }

    // Returns a comparable URL string for both string and Request fetch inputs.
    getFetchUrl(resource) {
      if (typeof resource === 'string') return resource;
      if (resource && typeof resource.url === 'string') return resource.url;
      return '';
    }

    shouldDisplayPopup() {
      const closedUntil = localStorage.getItem(this.hiddenUtilKey);
      if (!closedUntil) return true;
      const now = new Date().getTime();
      return now > parseInt(closedUntil);
    }

    async connectedCallback() {
      this.watchFetchEvents();
      await this.render();
      this.bindCartEvents();
      if (this.shouldDisplayPopup()) {
        this.style.display = 'block';
      }
    }

    // Watches cart mutations and ignores internal sync requests that were already
    // triggered by a previous customer action.
    watchFetchEvents() {
      if (!window.fetch || window.__giftPopupFetchWrapped) return;

      const originalFetch = window.fetch;
      window.__giftPopupFetchWrapped = true;

      window.fetch = async (resource, config) => {
        const url = this.getFetchUrl(resource);
        const isCartUpdate = url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change');
        const isInternalGiftSync = url.includes('free-gift') || url.includes('source=bxgy-gift');

        const response = await originalFetch(resource, config);

        if (response.ok && isCartUpdate && !isInternalGiftSync) {
          document.dispatchEvent(new CustomEvent('cart:after-update'));
        }
        return response;
      };
    }

    // Coalesces follow-up cart maintenance so rapid cart mutations do not spawn
    // overlapping popup refreshes or extra cart checks.
    async queueCartRefreshWork() {
      if (this.cartRefreshInFlight) {
        this.cartRefreshQueued = true;
        return this.cartRefreshInFlight;
      }

      this.cartRefreshInFlight = (async () => {
        do {
          this.cartRefreshQueued = false;
          await this.judgeCart();
          await this.updateFreeGifts();
        } while (this.cartRefreshQueued);
      })().finally(() => {
        this.cartRefreshInFlight = null;
      });

      return this.cartRefreshInFlight;
    }

    // Binds popup-specific cart listeners and routes them through the coalesced
    // maintenance path so the drawer is updated at most once per logical change.
    bindCartEvents() {
      document.addEventListener('cart:after-update', async evt => {
        await this.queueCartRefreshWork();
      });

      document.addEventListener('add:free-gift', async evt => {
        const variantId = evt.detail.variantId;
        await this.updateFreeGift(variantId);
        await this.updateFreeGifts();
      });
      function preventScrollThrough(el) {
        if (!el) return;

        el.addEventListener('touchstart', onTouchStart, { passive: false });
        el.addEventListener('touchmove', onTouchMove, { passive: false });

        let startY = 0;

        function onTouchStart(e) {
          startY = e.touches[0].clientY;
        }

        function onTouchMove(e) {
          const currentY = e.touches[0].clientY;
          const deltaY = currentY - startY;

          const scrollTop = el.scrollTop;
          const scrollHeight = el.scrollHeight;
          const offsetHeight = el.offsetHeight;

          const isAtTop = scrollTop === 0;
          const isAtBottom = scrollTop + offsetHeight >= scrollHeight - 1;

          // 向下滑，且已经在顶部
          if (deltaY > 0 && isAtTop) {
            e.preventDefault();
            return;
          }

          // 向上滑，且已经在底部
          if (deltaY < 0 && isAtBottom) {
            e.preventDefault();
            return;
          }

          e.stopPropagation();
          // 否则允许滑动（在内部正常滚动）
          // 注意：必须 passive: false 才能 preventDefault
        }
      }

      const popup = this.shadowRoot.querySelector('.popup');
      preventScrollThrough(popup);
  
      const closeBtn = this.shadowRoot.querySelector('div.icon-closex');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          const oneDayInMs = 24 * 60 * 60 * 1000;
          const tomorrow = new Date().getTime() + oneDayInMs;
          localStorage.setItem(this.hiddenUtilKey, tomorrow);
          this.style.display = 'none'; 
        });
      }

      this.style.display = 'block';
      var that = this;
      (async () => {
        async function init()  {
          await that.judgeCart();
          await that.updateFreeGifts();
        }

        if (document.readyState === 'complete' || document.readyState === 'interactive') {
          await init(); // 页面已加载
        } else {
          document.addEventListener('DOMContentLoaded', async () => {
            await init();
          });
        }
      })();
    }

    isBxgyGiftLine(item) {
      return Boolean(item && item.properties && item.properties._bxgy_gift === 'true');
    }

    getNonBxgyCartLinesByVariant(cart, variantId) {
      const id = parseInt(variantId, 10);
      if (!id || !cart || !Array.isArray(cart.items)) return [];

      return cart.items.filter(item => item.id === id && !this.isBxgyGiftLine(item));
    }

    

    async judgeCart() {
      const cart = await fetch(`${theme.routes.cart_url}.js`).then(res => res.json());
      const updates = {};
      // 自动移除不符合条件的赠品
      const freeGiftItems = Array.from(this.shadowRoot.querySelectorAll('.free-item'));
      Array.from(freeGiftItems).forEach(item => {
        const variantIds = item.dataset.variantIds.split(',').filter(Boolean);
        const threshold = parseInt(item.dataset.threshold);
        if (cart.total_price < threshold) {
          variantIds.forEach(id => {
            this.getNonBxgyCartLinesByVariant(cart, id).forEach(cartItem => {
              updates[cartItem.key] = 0;
            });
          });
        }
      });
      if (Object.keys(updates).length > 0) {
        await fetch(`${theme.routes.cart_update_url}?source=free-gift`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates
          })
        }).then(r => r.json());
        document.dispatchEvent(new CustomEvent('cart:drawer:update'));
      }
    }

    async updateFreeGift(variantId) {
      const cart = await fetch(`${theme.routes.cart_url}.js`).then(res => res.json());
      const freeGiftItems = Array.from(this.shadowRoot.querySelectorAll('.free-item'));
      const selectedVariantId = parseInt(variantId, 10);
      const add = {}, updates = {};
      // 先查询再购物车中的免费商品,移除并替换成新的
      Array.from(freeGiftItems).forEach(item => {
        item.dataset.variantIds.split(',')
          .filter(Boolean)
          .forEach(id => {
            this.getNonBxgyCartLinesByVariant(cart, id).forEach(cartItem => {
              if (cartItem.id !== selectedVariantId) {
                updates[cartItem.key] = 0;
              }
            });
          });
      });

      const selectedGiftAlreadyInCart = Array.isArray(cart.items) && cart.items.some(item => parseInt(item.id, 10) === selectedVariantId);
      if (!selectedGiftAlreadyInCart) {
        add[variantId] = 1;
      }

      if (Object.keys(updates).length > 0) {
        const updateResponse = await fetch(`${theme.routes.cart_update_url}?source=free-gift`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates
          })
        });
        updateResponse.json();
      }
      if (Object.keys(add).length > 0) {
        const addResponse = await fetch(`${theme.routes.cart_add_url}.js?source=free-gift`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: Object.keys(add).map(key => ({
              id: key,
              quantity: add[key]
            }))
          })
        });
        addResponse.json();
      }
      document.dispatchEvent(new CustomEvent('cart:drawer:update'));
    }

    async render() {
      await this.updateFreeGifts();
    }

    async updateFreeGifts() {
      const freeContainer = this.shadowRoot.querySelector('.free-container');
      if (freeContainer) {
        freeContainer.classList.add('is-loading');
      }
      try {
        const response = await fetch(`${theme.routes.root}?section_id=free-gift`)
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const freeGiftSection = doc.querySelector('.shopify-section');
        if (!this.classList.contains('gift-loaded')) {
           this.shadowRoot.innerHTML = freeGiftSection.innerHTML;
           this.classList.add('gift-loaded');
           this.bindPopupEvents();
        } else {
          this.shadowRoot.querySelector('.popup').innerHTML = doc.querySelector('.popup').innerHTML;
        }
        this.bindItemEvents();
      } finally {
        if (freeContainer) {
          freeContainer.classList.remove('is-loading');
        }
      }
    }

    bindPopupEvents() {
      const triggerBtn = this.shadowRoot.querySelector('.trigger-button');
      const popup = this.shadowRoot.querySelector('.popup');

      const toggleAction = () => {
        triggerBtn.classList.toggle('active');
        popup.classList.toggle('active');
      };

      triggerBtn.addEventListener('click', toggleAction);
      this.addEventListener('toggle:popup:hidden', () => {
        triggerBtn.classList.remove('active');
        popup.classList.remove('active');
      });
    }

    bindItemEvents() {
      const items = this.shadowRoot.querySelectorAll('.free-item');
      const freeContainer = this.shadowRoot.querySelector('.free-container');
      Array.from(items).forEach(item => {
        const seletor = item.querySelector('select')
        seletor.addEventListener('change', evt => {
          // 找到对应的option，然后把option上面的data-image属性值设置给图片.free-item__image img
          const option = evt.target.options[evt.target.selectedIndex];
          const image = item.querySelector('.free-item__image img');
          image.src = option.dataset.image;
        });

        const addActionNode = item.querySelector('.free-item__button');
        addActionNode.addEventListener('click', async () => {
          if (!this.loading) {
            freeContainer.classList.add('is-loading');
            const variantId = seletor.value;
            await this.updateFreeGift(variantId);
            await this.updateFreeGifts();
            freeContainer.classList.remove('is-loading');
          }
          this.loading = false;
          this.dispatchEvent(new CustomEvent('toggle:popup:hidden'));
        });
      });
    }
  }

  customElements.define('gift-popup-button', GiftPopupButton);
 
  // Layout toggles for collection page (desktop: 2/4, mobile: 1/2)
  function initCollectionLayoutToggles() {
    try {
      var products = document.querySelector('[data-collection-products]');
      var controls = document.querySelector('[data-layout-controls]');
      if (!products || !controls) {
        return;
      }
      // 新增：缓存按钮组容器（桌面/移动）
      var groupDesktop = controls.querySelector('.collection__layout-group--desktop');
      var groupMobile = controls.querySelector('.collection__layout-group--mobile');
      // 动态更新集合页商品图片的 sizes，使浏览器基于当前列数与容器宽度选择更清晰的 srcset 候选
      function updateGridImageSizes() {
        try {
          // 限定作用域：集合页产品网格
          var containers = products.querySelectorAll('[data-grid-image], [data-product-image-hover], .product__media__slide .product__media');
          var updatedCount = 0;
          containers.forEach(function(container) {
            var rect = container.getBoundingClientRect();
            var width = Math.round(rect && rect.width ? rect.width : 0);
            if (!width || width <= 0) return;
            var px = width + 'px';
            // 更新 picture/source 的 sizes（若存在）
            container.querySelectorAll('source').forEach(function(src) {
              src.setAttribute('sizes', px);
            });
            // 更新 img 的 sizes
            container.querySelectorAll('img').forEach(function(img) {
              img.setAttribute('sizes', px);
            });
            updatedCount += 1;
          });
          // 移除调试输出：不再打印更新计数
        } catch (e) {
          console.warn('[LayoutToggle] updateGridImageSizes failed', e);
        }
      }

      var desktopButtons = Array.from(controls.querySelectorAll('[data-layout-desktop]'));
      var mobileButtons = Array.from(controls.querySelectorAll('[data-layout-mobile]'));
      var LS_DESKTOP = 'collectionLayoutDesktop';
      var LS_MOBILE = 'collectionLayoutMobile';

      function setActive(buttons, value) {
        buttons.forEach(function(btn) {
          var val = btn.dataset.layoutDesktop || btn.dataset.layoutMobile;
          var isActive = String(val) === String(value);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          btn.classList.toggle('is-active', isActive);
        });
      }

      // Helper: detect tablet viewport
      function isTabletViewport() {
        var w = window.innerWidth || document.documentElement.clientWidth;
        return w >= 480 && w <= 1023;
      }

      // Helper: update desktop button labels to show 1/2 on tablet
      function updateTabletButtonLabels() {
        desktopButtons.forEach(function(btn) {
          var val = btn.dataset.layoutDesktop;
          if (!val) return;
          var labelText = isTabletViewport() ? (val === '2' ? '1' : '2') : val;
          // Do not alter button inner content; only update accessibility label
          btn.setAttribute('aria-label', (isTabletViewport() ? 'Tablet' : 'Desktop') + ' Columns ' + labelText);
        });
      }

      // Helper: when tablet is 1/2, ensure item width classes align (avoid overlay)
      function applyTabletItemWidthClasses(tabletRepeat) {
        if (!isTabletViewport()) return;
        var items = products.querySelectorAll('.product-grid-item.grid__item');
        items.forEach(function(it){
          it.classList.remove('one-whole','one-half','one-third','one-quarter');
          // reset any inline overrides first
          it.style.width = '';
          it.style.gridColumn = '';
          if (tabletRepeat === 1) {
            it.classList.add('one-whole');
            // force full-span on 1-col (480–1023) to beat utility widths
            it.style.width = '100%';
            it.style.gridColumn = '1 / -1';
          } else {
            it.classList.add('one-half');
          }
        });
      }

      // Helper: clear inline overrides when leaving tablet/mid viewport
      function clearTabletWidthOverrides() {
        var items = products.querySelectorAll('.product-grid-item.grid__item');
        items.forEach(function(it){
          it.style.width = '';
          it.style.gridColumn = '';
        });
      }

      // Helper: detect current tablet column count from grid
      function getCurrentTabletRepeat() {
        if (!isTabletViewport()) return null;
        var grid = products.querySelector('.grid');
        if (!grid) return null;
        var attr = grid.getAttribute('data-columns-tablet');
        if (attr) {
          var n = parseInt(attr, 10);
          if (!isNaN(n) && n > 0) return n;
        }
        // Try inline CSS var first (set by our JS)
        var varTablet = grid.style.getPropertyValue('--grid-tablet');
        if (varTablet) {
          var m = varTablet.match(/repeat\((\d+)/);
          if (m) {
            var n2 = parseInt(m[1], 10);
            if (!isNaN(n2) && n2 > 0) return n2;
          }
        }
        // Fallback: count computed columns even if browser expands to px values
        var computed = window.getComputedStyle(grid).getPropertyValue('grid-template-columns').trim();
        if (!computed) return null;
        var parts = computed.split(' ').filter(Boolean);
        return parts.length || null;
      }

      function setDesktopColumns(cols) {
        var c = String(cols);
        ['2','3','4'].forEach(function(n){ products.classList.remove('collection-items--' + n); });
        products.classList.add('collection-items--' + c);

        var items = products.querySelectorAll('.product-grid-item.grid__item');
        items.forEach(function(it){
          // Clear any leftover tablet inline overrides
          it.style.width = '';
          it.style.gridColumn = '';
          it.classList.remove('one-whole','one-half','one-third','one-quarter');
          if (c === '2') { it.classList.add('one-half'); }
          else if (c === '3') { it.classList.add('one-third'); }
          else { it.classList.add('one-quarter'); }
        });

        // Update grid container variables for desktop/tablet columns so CSS grid responds
        var grid = products.querySelector('.grid');
        if (grid) {
          // Map desktop to tablet: 2→1, 3→2, 4→2
          var desktopRepeat = (c === '2') ? 2 : (c === '3') ? 3 : 4;
          var tabletRepeat = (desktopRepeat === 2) ? 1 : 2;

          grid.setAttribute('data-columns-tablet', String(tabletRepeat));
          try {
            grid.style.setProperty('--grid', 'repeat(' + desktopRepeat + ', minmax(0, 1fr))');
            grid.style.setProperty('--grid-tablet', 'repeat(' + tabletRepeat + ', minmax(0, 1fr))');
            grid.style.setProperty('--grid-mobile', 'repeat(2, minmax(0, 1fr))');
            // 为容器标记 desktop 样式上下文
            products.classList.add('collection-items--desktop');
            products.classList.remove('collection-items--mobile--one-whole');
            products.classList.remove('collection-items--mobile--one-half');
          } catch (e) {
            console.warn('[LayoutToggle] Failed to set CSS vars', e);
          }

          // 移除调试输出：不再打印 Grid CSS 变量
          // var computed = window.getComputedStyle(grid);
          // console.log('[LayoutToggle] Grid CSS vars', { ... });
        }

        sessionStorage.setItem(LS_DESKTOP, c);
        setActive(desktopButtons, c);
        // 移除调试输出：不再打印 Desktop set
        // console.log('[LayoutToggle] Desktop set', { value: c, itemsUpdated: items.length, containerClasses: products.className });
        // 列数切换后更新图片 sizes（立即与稍后各触发一次，覆盖过渡）
        requestAnimationFrame(updateGridImageSizes);
        setTimeout(updateGridImageSizes, 250);
      }
      desktopButtons.forEach(function(btn){
        btn.addEventListener('click', function(){
          // 移除调试输出：不再打印 Desktop button click
          // console.log('[LayoutToggle] Desktop button click', { value: btn.dataset.layoutDesktop });
          setDesktopColumns(btn.dataset.layoutDesktop);
        });
      });

      function setMobileColumns(cols) {
        var c = String(cols);
        products.classList.remove('collection-items--mobile--one-whole','collection-items--mobile--one-half');
        var cls = c === '1' ? 'collection-items--mobile--one-whole' : 'collection-items--mobile--one-half';
        products.classList.add(cls);

        var items = products.querySelectorAll('.product-grid-item.grid__item');
        items.forEach(function(it){
          it.classList.remove('mobile--one-whole','mobile--one-half');
          if (c === '1') { it.classList.add('mobile--one-whole'); }
          else { it.classList.add('mobile--one-half'); }
        });

        var grid = products.querySelector('.grid');
        if (grid) {
          grid.setAttribute('data-columns-mobile', c);
          var mobileRepeat = (c === '1') ? 1 : 2;
          try {
            // ≤479 use --grid-mobile; 480–767 still use --grid-tablet
            grid.style.setProperty('--grid-mobile', 'repeat(' + mobileRepeat + ', minmax(0, 1fr))');
            grid.style.setProperty('--grid-tablet', 'repeat(' + mobileRepeat + ', minmax(0, 1fr))');
            // In 480–1023 apply tablet width fix directly; avoid relying on column detection
            grid.setAttribute('data-columns-tablet', String(mobileRepeat));
            if (isTabletViewport()) {
              applyTabletItemWidthClasses(mobileRepeat);
            }
          } catch (e) {
            console.warn('[LayoutToggle] Failed to set mobile CSS vars', e);
          }
        }

        // If in 480–1023 range, apply width fix based on current column count
        var currentTablet = getCurrentTabletRepeat();
        if (currentTablet) applyTabletItemWidthClasses(currentTablet);

        sessionStorage.setItem(LS_MOBILE, c);
        setActive(mobileButtons, c);
        // 移除调试输出：不再打印 Mobile set
        // console.log('[LayoutToggle] Mobile set', { value: c, itemsUpdated: items.length, containerClasses: products.className });
        // 列数切换后更新图片 sizes（立即与稍后各触发一次，覆盖过渡）
        requestAnimationFrame(updateGridImageSizes);
        setTimeout(updateGridImageSizes, 250);
      }

      mobileButtons.forEach(function(btn){
        btn.addEventListener('click', function(){
          // 移除调试输出：不再打印 Mobile button click
          // console.log('[LayoutToggle] Mobile button click', { value: btn.dataset.layoutMobile });
          setMobileColumns(btn.dataset.layoutMobile);
        });
      });

      // 新增：根据断点显示正确的按钮组（桌面2/4 vs 平板/移动1/2）
      function updateVisibleToggleButtons() {
        var w = window.innerWidth || document.documentElement.clientWidth;
        var isDesktop = w >= 1024;
        // 先切换按钮本身（可访问性）
        desktopButtons.forEach(function(btn){
          btn.style.display = isDesktop ? '' : 'none';
          btn.setAttribute('aria-hidden', isDesktop ? 'false' : 'true');
          btn.tabIndex = isDesktop ? 0 : -1;
        });
        mobileButtons.forEach(function(btn){
          btn.style.display = isDesktop ? 'none' : '';
          btn.setAttribute('aria-hidden', isDesktop ? 'true' : 'false');
          btn.tabIndex = isDesktop ? -1 : 0;
        });
        // 再切换按钮组容器（覆盖CSS在768+隐藏移动组的规则）
        if (groupDesktop) {
          groupDesktop.style.display = isDesktop ? 'inline-flex' : 'none';
          groupDesktop.setAttribute('aria-hidden', isDesktop ? 'false' : 'true');
        }
        if (groupMobile) {
          groupMobile.style.display = isDesktop ? 'none' : 'inline-flex';
          groupMobile.setAttribute('aria-hidden', isDesktop ? 'true' : 'false');
        }
      }

      // 新增：会话布局重应用函数（用于筛选/排序/无限滚动后）
      function applyLayoutFromSession() {
        try {
          var d = sessionStorage.getItem(LS_DESKTOP);
          var m = sessionStorage.getItem(LS_MOBILE);
          var w = window.innerWidth || document.documentElement.clientWidth;
          var isDesktop = w >= 1024;
          if (isDesktop) {
            setDesktopColumns(d || '4');
          } else {
            setMobileColumns(m || '2');
          }
        } catch (e) {
          console.warn('[LayoutToggle] applyLayoutFromSession failed', e);
        }
      }

      // Initialize pressed states based on existing classes or saved preferences
      var savedDesktop = sessionStorage.getItem(LS_DESKTOP);
       var savedMobile = sessionStorage.getItem(LS_MOBILE);

      function detectDesktop() {
        if (products.classList.contains('collection-items--4')) return '4';
        if (products.classList.contains('collection-items--3')) return '3';
        if (products.classList.contains('collection-items--2')) return '2';
        return null;
      }
      function detectMobile() {
        if (products.classList.contains('collection-items--mobile--one-whole')) return '1';
        if (products.classList.contains('collection-items--mobile--one-half')) return '2';
        return null;
      }

      setActive(desktopButtons, savedDesktop || '4');
       setActive(mobileButtons, savedMobile || '2');

      // 默认/会话：首次应用一次
      applyLayoutFromSession();
      updateVisibleToggleButtons();
      updateTabletButtonLabels();
      var __gridSizesResizeTimer;
      window.addEventListener('resize', function(){
        updateTabletButtonLabels();
        updateVisibleToggleButtons();
        var repeat = getCurrentTabletRepeat();
        if (repeat) applyTabletItemWidthClasses(repeat);
        // When leaving ≤1023 viewport, clear inline overrides
        if (!isTabletViewport()) clearTabletWidthOverrides();
        // Debounced update of image sizes on viewport change + 断点切换时重应用会话布局
        clearTimeout(__gridSizesResizeTimer);
        __gridSizesResizeTimer = setTimeout(function(){
          updateGridImageSizes();
          applyLayoutFromSession();
        }, 120);
      });

      // removed persistence: no saved layout applied

      // 监听延迟加载的 <deferred-loading> 完成，加载后刷新相关图片的 sizes
      try {
        var deferreds = products.querySelectorAll('deferred-loading');
        var __deferredObserver = new MutationObserver(function(mutations){
          var needsUpdate = false;
          mutations.forEach(function(m){
            if (m.type === 'attributes' && m.attributeName === 'data-loaded') {
              needsUpdate = true;
            }
          });
          if (needsUpdate) {
            requestAnimationFrame(updateGridImageSizes);
            setTimeout(updateGridImageSizes, 150);
          }
        });
        deferreds.forEach(function(dl){
          __deferredObserver.observe(dl, { attributes: true, attributeFilter: ['data-loaded'] });
        });
      } catch (e) {
        console.warn('[LayoutToggle] deferred observer init failed', e);
      }

      // 新增：监听产品网格内容变更（筛选/排序/无限滚动），重新应用当前布局
      try {
        var __gridContentObserver = new MutationObserver(function(mutations){
          var needReapply = false;
          mutations.forEach(function(m){
            if (m.type === 'childList') {
              needReapply = true;
            }
          });
          if (needReapply) {
            setTimeout(function(){
              applyLayoutFromSession();
              requestAnimationFrame(updateGridImageSizes);
              setTimeout(updateGridImageSizes, 150);
            }, 60);
          }
        });
        __gridContentObserver.observe(products, { childList: true, subtree: true });
      } catch (e) {
        console.warn('[LayoutToggle] grid content observer init failed', e);
      }

      // 监听可见性类名变化（featured/hover 变更）以在切换颜色后刷新 sizes
      try {
        var __classObserverTimer;
        var __visibilityClassObserver = new MutationObserver(function(mutations){
          var needUpdate = false;
          mutations.forEach(function(m){
            if (m.type === 'attributes' && m.attributeName === 'class') {
              var el = m.target;
              if (el && (el.classList?.contains('product__media--featured-visible') || el.classList?.contains('product__media__hover-img--visible'))) {
                needUpdate = true;
              }
            }
          });
          if (needUpdate) {
            clearTimeout(__classObserverTimer);
            __classObserverTimer = setTimeout(function(){
              requestAnimationFrame(updateGridImageSizes);
            }, 80);
          }
        });
        __visibilityClassObserver.observe(products, { subtree: true, attributes: true, attributeFilter: ['class'] });
      } catch (e) {
        console.warn('[LayoutToggle] visibility class observer init failed', e);
      }
      // Apply tablet width correction on first load if applicable
      var initialTabletRepeat = getCurrentTabletRepeat();
      if (initialTabletRepeat) applyTabletItemWidthClasses(initialTabletRepeat);

      // 初始化完成后触发一次图片 sizes 更新，确保默认布局下清晰度正确
      requestAnimationFrame(updateGridImageSizes);
      setTimeout(updateGridImageSizes, 250);

      // 移除调试输出：不再打印初始化信息
      // console.log('[LayoutToggle] Initialized', { ... });

    } catch (e) {
      // 移除调试输出：不再打印错误信息
      // console.log('[LayoutToggle] Error', e);
      // Silent fail to avoid breaking other theme scripts
    }
  }

  onReady(initCollectionLayoutToggles);
  document.addEventListener('shopify:section:load', initCollectionLayoutToggles);

  // Product Tag Details Popover
  function initTagDetailsPopover() {
    console.log('[TagDetails] Initializing tag details popover...');
    
    // 检查页面上是否有tag元素
    var tags = document.querySelectorAll('[data-tag-details]');
    console.log('[TagDetails] Found ' + tags.length + ' tags with data-tag-details');
    
    // 为所有带有 data-tag-details 的标签添加点击事件（事件委托）
    document.addEventListener('click', function(e) {
      console.log('[TagDetails] Click detected on:', e.target);
      var tagEl = e.target.closest('[data-tag-details]');
      if (tagEl) {
        console.log('[TagDetails] Tag clicked!', tagEl);
        e.preventDefault();
        e.stopPropagation();
        openTagPopover(tagEl);
      }
    });

    // ESC键关闭
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var popover = document.getElementById('tagDetailsPopover');
        if (popover && popover.classList.contains('active')) {
          closeTagPopover();
        }
      }
    });
  }

  function openTagPopover(tagEl) {
    console.log('[TagDetails] Opening popover for tag:', tagEl);
    var popover = document.getElementById('tagDetailsPopover');
    if (!popover) {
      console.warn('[TagDetails] Popover element not found in DOM');
      return;
    }

    var popoverContent = popover.querySelector('.tag-details-popover__content');
    var popoverArrow = popover.querySelector('.tag-details-popover__arrow');
    var titleEl = popover.querySelector('.tag-details-popover__title');
    var bodyEl = popover.querySelector('.tag-details-popover__body');

    var color = tagEl.dataset.tagColor || '#000';
    var title = tagEl.dataset.tagTitle || '';
    var tagIndex = tagEl.dataset.tagIndex || '0';
    
    // 从隐藏的 div 中读取已渲染的富文本内容
    var contentEl = tagEl.querySelector('[data-tag-content-' + tagIndex + ']');
    var content = contentEl ? contentEl.innerHTML.trim() : '';

    console.log('[TagDetails] Tag data:', { color: color, title: title, content: content });

    // 如果 details 为空，不显示弹出框
    if (!content || content === '') {
      console.warn('[TagDetails] Details is empty, not showing popover');
      return;
    }
    
    // 如果标题和内容都为空，也不显示
    if (!title && !content) {
      console.warn('[TagDetails] No title or content, not showing popover');
      return;
    }

    // 设置边框和箭头颜色
    popoverContent.style.borderColor = color;
    if (popoverArrow) {
      popoverArrow.style.borderBottomColor = color;
    }
    
    // 设置标题和颜色
    titleEl.textContent = title;
    titleEl.style.color = color;
    
    // 设置内容（富文本）
    bodyEl.innerHTML = content;

    // 计算位置
    var tagRect = tagEl.getBoundingClientRect();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    
    // 先显示但透明，以便获取尺寸
    popover.style.display = 'block';
    popover.style.opacity = '0';
    popover.style.visibility = 'visible';
    
    var popoverRect = popover.getBoundingClientRect();
    var popoverWidth = popoverRect.width;
    var popoverHeight = popoverRect.height;
    
    // 计算初始位置：tag下方居中
    var top = tagRect.bottom + scrollTop + 12;
    var left = tagRect.left + scrollLeft + (tagRect.width / 2) - (popoverWidth / 2);
    
    // 边界检测和调整
    var viewportWidth = window.innerWidth;
    var viewportHeight = window.innerHeight;
    var minMargin = 20;
    
    // 左边界检测
    if (left < minMargin) {
      left = minMargin;
    }
    
    // 右边界检测
    if (left + popoverWidth > viewportWidth - minMargin) {
      left = viewportWidth - popoverWidth - minMargin;
    }
    
    // 垂直方向检测：判断上方还是下方显示
    var showAbove = false;
    var spaceBelow = viewportHeight - (tagRect.bottom - scrollTop) - minMargin;
    var spaceAbove = tagRect.top - scrollTop - minMargin;
    
    // 如果下方空间不够，且上方空间更大，则显示在上方
    if (spaceBelow < popoverHeight + 12) {
      if (spaceAbove > spaceBelow && spaceAbove >= popoverHeight + 12) {
        showAbove = true;
        top = tagRect.top + scrollTop - popoverHeight - 12;
      }
    }
    
    // 设置位置
    popover.style.top = top + 'px';
    popover.style.left = left + 'px';
    
    // 调整箭头位置
    if (popoverArrow) {
      var arrowLeft = tagRect.left + scrollLeft + (tagRect.width / 2) - left - 9;
      arrowLeft = Math.max(20, Math.min(arrowLeft, popoverWidth - 40));
      popoverArrow.style.left = arrowLeft + 'px';
      
      // 如果在上方显示，翻转箭头
      if (showAbove) {
        popoverArrow.style.top = 'auto';
        popoverArrow.style.bottom = '-9px';
        popoverArrow.style.transform = 'rotate(180deg)';
      } else {
        popoverArrow.style.top = '-8px';
        popoverArrow.style.bottom = 'auto';
        popoverArrow.style.transform = 'none';
      }
    }

    // 显示弹出框（带动画）
    popover.style.opacity = '';
    popover.style.visibility = '';
    requestAnimationFrame(function() {
      popover.classList.add('active');
    });

    // 绑定关闭按钮（每次打开时绑定，避免重复绑定）
    if (!popover.dataset.eventsbound) {
      var closeBtn = popover.querySelector('.tag-details-popover__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', closeTagPopover);
      }

      // 点击外部区域关闭
      document.addEventListener('click', function outsideClickHandler(e) {
        if (!popover.contains(e.target) && !e.target.closest('[data-tag-details]')) {
          closeTagPopover();
        }
      });

      popover.dataset.eventsbound = 'true';
    }
  }

  function closeTagPopover() {
    var popover = document.getElementById('tagDetailsPopover');
    if (!popover) return;
    
    popover.classList.remove('active');
    setTimeout(function() {
      popover.style.display = 'none';
      popover.style.visibility = 'hidden';
    }, 200);
  }

  onReady(initTagDetailsPopover);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

// Product Discount Checkbox Handler
(function() {
  class ProductDiscountHandler {
    constructor() {
      this.checkboxSelector = '[data-discount-option] input[type="checkbox"]';
      this.pendingAddDiscountCheckbox = null;
      this.isUpdating = false;
      
      this.init();
    }

    init() {
      var self = this;
      
      this.restoreAllCheckboxStates();
      this.watchCheckboxChanges();
      this.watchDynamicCheckboxes();
      this.watchAddToCart();
      this.watchCartUpdates();
      this.watchPageVisibility();
      
      setTimeout(function() {
        self.syncCheckedCheckboxWithCart();
      }, 500);
    }

    watchCheckboxChanges() {
      var self = this;

      document.addEventListener('change', function(e) {
        if (!e.target.matches(self.checkboxSelector)) return;
        self.handleCheckboxChange(e);
      });
    }

    handleCheckboxChange(e) {
      var self = this;
      var isChecked = e.target.checked;
      
      if (self.isUpdating) return;
      
      self.isUpdating = true;
      self.setLoadingState(e.target, true);
      
      self.updateCartDiscount(e.target, isChecked)
        .then(function(cart) {
          self.saveCheckboxState(e.target, isChecked);
          self.syncDiscountOptionState(e.target);
          self.triggerCartUpdate(false);
        })
        .catch(function(error) {
          e.target.checked = !isChecked;
          self.syncDiscountOptionState(e.target);
        })
        .finally(function() {
          self.setLoadingState(e.target, false);
          self.isUpdating = false;
        });
    }

    updateCartDiscount(checkbox, apply) {
      var discountCode = this.getDiscountCode(checkbox);
      var discountValue = apply ? discountCode : '';

      if (!discountCode) {
        return Promise.resolve();
      }
      
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: discountValue })
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      });
    }

    watchAddToCart() {
      var self = this;

      document.addEventListener('submit', function(e) {
        var checkbox = self.findCheckedDiscountCheckbox(e.target);

        if (checkbox) {
          self.pendingAddDiscountCheckbox = checkbox;
          setTimeout(function() {
            self.updateCartDiscount(checkbox, true).catch(console.error);
          }, 500);
        }
      }, true);

      document.addEventListener('theme:cart:add', function(e) {
        var source = e.detail && e.detail.selector;
        var checkbox = self.findCheckedDiscountCheckbox(self.getProductScope(source));

        if (checkbox) {
          self.pendingAddDiscountCheckbox = checkbox;
        }
      });

      document.addEventListener('theme:cart:added', function() {
        var checkbox = self.pendingAddDiscountCheckbox;
        self.pendingAddDiscountCheckbox = null;

        if (checkbox && checkbox.checked) {
          self.updateCartDiscount(checkbox, true)
            .then(function() {
              self.saveCheckboxState(checkbox, true);
              self.triggerCartUpdate(true);
            })
            .catch(console.error);
        }
      });

      document.addEventListener('cart:item-added', function() {
        var checkbox = self.findCheckedDiscountCheckbox(document);

        if (checkbox) {
          self.updateCartDiscount(checkbox, true).catch(console.error);
        }
      });
    }

    watchDynamicCheckboxes() {
      var self = this;

      if (!window.MutationObserver) return;

      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (!node.querySelectorAll) return;

            var checkboxes = [];
            if (node.matches && node.matches(self.checkboxSelector)) {
              checkboxes.push(node);
            }

            node.querySelectorAll(self.checkboxSelector).forEach(function(checkbox) {
              checkboxes.push(checkbox);
            });

            checkboxes.forEach(function(checkbox) {
              self.restoreCheckboxState(checkbox);
            });
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    watchCartUpdates() {
      var self = this;
      
      document.addEventListener('cart:updated', function() {
        self.syncCheckedCheckboxWithCart();
      });

      document.addEventListener('cart:drawer:open', function() {
        self.syncCheckedCheckboxWithCart();
      });
      
      document.addEventListener('theme:cart:open', function() {
        setTimeout(function() {
          self.syncCheckedCheckboxWithCart();
        }, 50);
      });
    }

    watchPageVisibility() {
      var self = this;
      
      document.addEventListener('visibilitychange', function() {
        if (!document.hidden) {
          self.syncCheckedCheckboxWithCart();
        }
      });
      
      window.addEventListener('focus', function() {
        self.syncCheckedCheckboxWithCart();
      });
    }

    syncCheckedCheckboxWithCart() {
      var checkbox = document.querySelector(this.checkboxSelector + ':checked') || document.querySelector(this.checkboxSelector);

      if (!checkbox) {
        return Promise.resolve();
      }

      return this.syncCheckboxWithCart(checkbox);
    }

    syncCheckboxWithCart(checkbox) {
      var self = this;
      var discountCode = self.getDiscountCode(checkbox);

      if (!discountCode) {
        return Promise.resolve();
      }
      
      if (self.isUpdating) {
        return Promise.resolve();
      }
      
      return fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          if (self.isUpdating) {
            return cart;
          }
          
          var hasThisDiscount = cart.cart_level_discount_applications && 
            cart.cart_level_discount_applications.some(function(discount) {
              return discount.title === discountCode || discount.code === discountCode;
            });
          
          var isChecked = checkbox.checked;
          
          console.log('[ProductDiscount] Sync check:', {
            checkboxChecked: isChecked,
            cartHasDiscount: hasThisDiscount,
            needUpdate: isChecked !== hasThisDiscount
          });
          
          // If checkbox and cart are out of sync, silently update cart to match checkbox
          if (isChecked !== hasThisDiscount) {
            console.log('[ProductDiscount] Silently syncing cart to match checkbox state');
            self.isUpdating = true;
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ discount: isChecked ? discountCode : '' })
            })
              .then(function(response) {
                if (!response.ok) throw new Error('Cart update failed');
                return response.json();
              })
              .then(function() {
                // Silent update, no drawer refresh
                return cart;
              })
              .finally(function() {
                self.isUpdating = false;
              });
          }
          
          return cart;
        })
        .catch(function(error) {
          console.error('[ProductDiscount] Sync failed:', error);
        });
    }

    saveCheckboxState(checkbox, isChecked) {
      try {
        var storageKey = this.getStorageKey(checkbox);

        if (storageKey) {
          localStorage.setItem(storageKey, isChecked ? '1' : '0');
        }
      } catch (e) {}
    }

    restoreAllCheckboxStates() {
      var self = this;

      document.querySelectorAll(this.checkboxSelector).forEach(function(checkbox) {
        self.restoreCheckboxState(checkbox);
      });
    }

    restoreCheckboxState(checkbox) {
      try {
        var storageKey = this.getStorageKey(checkbox);
        var saved = storageKey ? localStorage.getItem(storageKey) : null;

        if (saved === '1') {
          checkbox.checked = true;
        } else if (saved === '0') {
          checkbox.checked = false;
        }
      } catch (e) {}

      this.syncDiscountOptionState(checkbox);
    }

    // Keep the discount option container in sync with the checkbox state.
    syncDiscountOptionState(checkbox) {
      var wrapper = checkbox && checkbox.closest ? checkbox.closest('[data-discount-option]') : null;

      if (wrapper) {
        wrapper.classList.toggle('is-checked', !!checkbox.checked);
      }
    }

    setLoadingState(checkbox, loading) {
      var wrapper = checkbox.closest('[data-discount-option]');
      var label = checkbox.closest('.discount-checkbox-label');

      if (wrapper) {
        if (loading) {
          wrapper.classList.add('is-loading');
        } else {
          wrapper.classList.remove('is-loading');
        }
      }

      if (label) {
        if (loading) {
          label.classList.add('is-loading');
        } else {
          label.classList.remove('is-loading');
        }
      }

      checkbox.disabled = loading;
    }

    getProductScope(source) {
      if (!source || !source.closest) {
        return document;
      }

      return source.closest('[data-product]') ||
        source.closest('[data-quick-view-item]') ||
        source.closest('.popup-quick-view') ||
        source.closest('.product__wrapper') ||
        document;
    }

    findCheckedDiscountCheckbox(scope) {
      var context = scope && scope.querySelector ? scope : document;
      var checkbox = context.querySelector(this.checkboxSelector + ':checked');

      if (checkbox) {
        return checkbox;
      }

      return document.querySelector(this.checkboxSelector + ':checked');
    }

    getDiscountCode(checkbox) {
      return checkbox && checkbox.dataset ? checkbox.dataset.discountCode : '';
    }

    getStorageKey(checkbox) {
      var productId = checkbox && checkbox.dataset ? checkbox.dataset.productId : '';

      return productId ? 'discount_applied_' + productId : '';
    }

    showToast(message, type) {
      type = type || 'success';
      
      if (window.theme && window.theme.showNotification) {
        window.theme.showNotification(message, type);
        return;
      }
      
      var toast = document.createElement('div');
      toast.className = 'product-discount-toast product-discount-toast--' + type;
      toast.textContent = message;
      toast.style.cssText = 'position: fixed; bottom: 30px; right: 30px; background: ' + 
        (type === 'error' ? '#dc2626' : '#a69072') + 
        '; color: white; padding: 12px 20px; border-radius: 8px; z-index: 9999; font-size: 14px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); animation: slideInUp 0.3s ease;';
      
      document.body.appendChild(toast);
      
      setTimeout(function() {
        toast.style.animation = 'slideOutDown 0.3s ease';
        setTimeout(function() { toast.remove(); }, 300);
      }, 3000);
    }

    triggerCartUpdate(force) {
      var isDrawerOpen = document.body.classList.contains('cart-drawer--open') ||
        document.body.classList.contains('js-drawer-open-cart');
      
      if (force || isDrawerOpen) {
        document.dispatchEvent(new CustomEvent('cart:drawer:update'));
      }
    }
  }

  function init() {
    new ProductDiscountHandler();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  if (!document.querySelector('style[data-discount-toast-animations]')) {
    var style = document.createElement('style');
    style.setAttribute('data-discount-toast-animations', 'true');
    style.textContent = '@keyframes slideInUp { from { transform: translateY(100%); opacity: 0; } to { transform: translateY(0); opacity: 1; } } @keyframes slideOutDown { from { transform: translateY(0); opacity: 1; } to { transform: translateY(100%); opacity: 0; } }';
    document.head.appendChild(style);
  }
})();

// Inject styles into Shopify Inbox chat Shadow DOM
(function() {
  function injectChatToggleStyle(shadowRoot) {
    if (!shadowRoot) return;
    if (shadowRoot.querySelector('style[data-chat-toggle-style]')) return;

    var style = document.createElement('style');
    style.setAttribute('data-chat-toggle-style', 'true');
    style.textContent = [
      '@media (max-width: 768px) {',
      '  button.chat-toggle.chat-toggle--icon-button {',
      '    position: fixed !important;',
      '    bottom: 11vh !important;',
      '    right: 0 !important;',
      '  }',
      '}'
    ].join('\n');

    try {
      shadowRoot.appendChild(style);
    } catch (e) {
      // Silent fail
    }
  }

  function applyForHost(host) {
    if (!host) return;
    var sr = host.shadowRoot;
    if (!sr) return;
    injectChatToggleStyle(sr);

    // Observe ShadowRoot for internal rerenders and ensure style persists
    var OBS_KEY = '__chatToggleSRObserver';
    if (!sr[OBS_KEY]) {
      var obs = new MutationObserver(function() {
        injectChatToggleStyle(sr);
      });
      try {
        obs.observe(sr, { childList: true, subtree: true });
        sr[OBS_KEY] = obs;
      } catch (e) {}
    }
  }

  function init() {
    // Apply to existing hosts
    var hosts = document.querySelectorAll('inbox-online-store-chat');
    hosts.forEach(applyForHost);

    // Observe document for dynamically injected hosts
    var DOC_KEY = '__chatToggleHostObserver';
    if (!document[DOC_KEY]) {
      var docObs = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          m.addedNodes && m.addedNodes.forEach(function(n) {
            if (n && n.nodeType === 1 && n.matches && n.matches('inbox-online-store-chat')) {
              applyForHost(n);
            }
          });
        });
      });
      try {
        docObs.observe(document.body || document.documentElement, { childList: true, subtree: true });
        document[DOC_KEY] = docObs;
      } catch (e) {}
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

(function() {
  var variantChangeHandlers = [];
  var variantChangeListenerAdded = false;
  
  function initSeeVideoButton() {
    var seeVideoButtons = document.querySelectorAll('[data-see-video-button]');
    if (!seeVideoButtons || seeVideoButtons.length === 0) return;
    
    seeVideoButtons.forEach(function(button) {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      
      var productGallery = button.closest('[data-product-single-media-group]');
      if (!productGallery) return;
      
      var slider = productGallery.querySelector('[data-product-single-media-slider]');
      if (!slider) return;
      
      var cachedSlides = null;
      var lastSlideType = null;
      var updateScheduled = false;
      
      function getCachedSlides() {
        if (!cachedSlides) {
          cachedSlides = slider.querySelectorAll('[data-product-slide]');
        }
        return cachedSlides;
      }
      
      function updateButtonVisibility() {
        if (updateScheduled) return;
        updateScheduled = true;
        
        requestAnimationFrame(function() {
          updateScheduled = false;
          var allSlides = getCachedSlides();
          var currentSlide = slider.querySelector('[data-product-slide].is-selected');
          
          if (!currentSlide) {
            for (var i = 0; i < allSlides.length; i++) {
              var slide = allSlides[i];
              if (!slide.classList.contains('media--hidden')) {
                currentSlide = slide;
                break;
              }
            }
          }
          
          if (!currentSlide && allSlides.length > 0) {
            currentSlide = allSlides[0];
          }
          
          if (currentSlide) {
            var slideType = currentSlide.dataset.type;
            var isVideo = slideType === 'video' || slideType === 'external_video' || currentSlide.hasAttribute('data-video');
            
            if (lastSlideType === isVideo) return;
            lastSlideType = isVideo;
            
            if (isVideo) {
              button.style.opacity = '0';
              button.style.pointerEvents = 'none';
              button.style.visibility = 'hidden';
            } else {
              button.style.opacity = '1';
              button.style.pointerEvents = 'auto';
              button.style.visibility = 'visible';
            }
          }
        });
      }
      
      setTimeout(updateButtonVisibility, 100);
      
      var flkty = null;
      var flickityHandler = function() {
        updateButtonVisibility();
      };
      
      if (window.theme && window.theme.Flickity) {
        flkty = window.theme.Flickity.data(slider);
        if (flkty) {
          flkty.on('change', flickityHandler);
        }
      }
      
      var mutationTimeout;
      var observer = new MutationObserver(function() {
        clearTimeout(mutationTimeout);
        mutationTimeout = setTimeout(function() {
          cachedSlides = null;
          updateButtonVisibility();
        }, 100);
      });
      
      observer.observe(slider, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: false
      });
      
      var scrollTimeout;
      var scrollHandler = function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateButtonVisibility, 150);
      };
      slider.addEventListener('scroll', scrollHandler, { passive: true });
      
      var variantHandler = function() {
        cachedSlides = null;
        setTimeout(updateButtonVisibility, 200);
      };
      variantChangeHandlers.push(variantHandler);
      
      if (!variantChangeListenerAdded) {
        variantChangeListenerAdded = true;
        document.addEventListener('theme:variant:change', function() {
          variantChangeHandlers.forEach(function(handler) {
            handler();
          });
        });
      }
      
      button._cleanup = function() {
        if (observer) observer.disconnect();
        if (slider) slider.removeEventListener('scroll', scrollHandler);
        if (flkty) flkty.off('change', flickityHandler);
        var index = variantChangeHandlers.indexOf(variantHandler);
        if (index > -1) variantChangeHandlers.splice(index, 1);
      };
      
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        var videoIndex = parseInt(button.dataset.videoIndex, 10);
        if (isNaN(videoIndex) || videoIndex < 0) return;
        
        var allSlides = getCachedSlides();
        if (videoIndex >= allSlides.length) return;
        
        var videoSlide = allSlides[videoIndex];
        if (!videoSlide) return;
        
        var slideType = videoSlide.dataset.type;
        var hasVideoAttr = videoSlide.hasAttribute('data-video');
        var isVideoSlide = slideType === 'video' || slideType === 'external_video' || hasVideoAttr;
        
        if (!isVideoSlide) {
          var foundVideo = false;
          for (var i = 0; i < allSlides.length; i++) {
            var slide = allSlides[i];
            var type = slide.dataset.type;
            if (type === 'video' || type === 'external_video' || slide.hasAttribute('data-video')) {
              videoIndex = i;
              videoSlide = slide;
              foundVideo = true;
              break;
            }
          }
          if (!foundVideo) return;
        }
        
        var flktyClick = null;
        if (window.theme && window.theme.Flickity) {
          flktyClick = window.theme.Flickity.data(slider);
        }
        
        if (flktyClick) {
          flktyClick.select(videoIndex, false, true);
          setTimeout(function() {
            triggerVideoPlayback(videoSlide);
            updateButtonVisibility();
          }, 400);
        } else {
          videoSlide.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'nearest' 
          });
          setTimeout(function() {
            triggerVideoPlayback(videoSlide);
            updateButtonVisibility();
          }, 600);
        }
        
        button.style.transform = 'scale(0.95)';
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            button.style.transform = '';
          });
        });
      });
    });
  }
  
  function triggerVideoPlayback(videoSlide) {
    if (!videoSlide) return;
    
    function resetVideoToStart(videoElement) {
      if (!videoElement) return;
      try {
        if (videoElement.tagName === 'VIDEO') {
          videoElement.currentTime = 0;
          videoElement.pause();
          return true;
        }
        if (videoElement.tagName === 'IFRAME') {
          var src = videoElement.src || '';
          if (src.indexOf('youtube.com') > -1 || src.indexOf('youtu.be') > -1) {
            try {
              videoElement.contentWindow.postMessage('{"event":"command","func":"seekTo","args":[0,true]}', '*');
            } catch (e) {}
            var currentSrc = videoElement.src;
            if (currentSrc.indexOf('autoplay=1') === -1) {
              videoElement.src = currentSrc + (currentSrc.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
            }
            return true;
          }
          if (src.indexOf('vimeo.com') > -1) {
            try {
              videoElement.contentWindow.postMessage('{"method":"setCurrentTime","value":0}', '*');
            } catch (e) {}
            return true;
          }
        }
      } catch (error) {}
      return false;
    }
    
    var deferredMedia = videoSlide.querySelector('[data-deferred-media]');
    if (deferredMedia) {
      var video = deferredMedia.querySelector('video');
      var iframe = deferredMedia.querySelector('iframe');
      if (video) {
        resetVideoToStart(video);
      } else if (iframe) {
        resetVideoToStart(iframe);
      }
      var playButton = deferredMedia.querySelector('[data-deferred-media-button]');
      if (playButton) {
        playButton.click();
        setTimeout(function() {
          var loadedVideo = deferredMedia.querySelector('video');
          var loadedIframe = deferredMedia.querySelector('iframe');
          if (loadedVideo) {
            resetVideoToStart(loadedVideo);
            loadedVideo.play().catch(function() {});
          } else if (loadedIframe) {
            resetVideoToStart(loadedIframe);
          }
        }, 500);
      }
    } else {
      var video = videoSlide.querySelector('video');
      var iframe = videoSlide.querySelector('iframe');
      if (video && typeof video.play === 'function') {
        resetVideoToStart(video);
        video.play().catch(function() {});
      } else if (iframe) {
        resetVideoToStart(iframe);
      }
    }
  }
  
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }
  
  onReady(initSeeVideoButton);
  document.addEventListener('shopify:section:load', initSeeVideoButton);
  document.addEventListener('theme:render:product', initSeeVideoButton);
})();

// Global Scroll to Top Button
(function() {
  var scrollTopIcon = '<svg class="icon" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" width="48" height="48" aria-hidden="true"><defs><filter id="shadow" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur in="SourceAlpha" stdDeviation="2"/><feOffset dx="0" dy="2" result="offsetblur"/><feComponentTransfer><feFuncA type="linear" slope="0.3"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs><path d="M24 16 L24 32 M16 24 L24 16 L32 24" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';
  function initGlobalScrollToTop() {
    var body = document.body;
    if (!body) return;
    // Check if button already exists
    var button = document.querySelector('[data-global-scroll-to-top]');
    
    if (!button) {
      // Create button
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'btn btn--primary btn--solid btn--scroll-top';
      button.setAttribute('data-global-scroll-to-top', '');
      button.setAttribute('aria-label', 'Scroll to top');
      button.innerHTML = scrollTopIcon;
      body.appendChild(button);
    }
    // Bind click event
    if (!button.__scrollToTopClickBound) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      });
      button.__scrollToTopClickBound = true;
    }
    // Update visibility based on has-scrolled class
    function updateVisibility() {
      if (!button) return;
      var hasScrolled = body.classList.contains('has-scrolled');
      button.classList.toggle('is-visible', hasScrolled);
    }
    // Initial update
    updateVisibility();
    // Observe body class changes for has-scrolled
    if (!window.__scrollToTopObserver) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            updateVisibility();
          }
        });
      });
      
      observer.observe(body, {
        attributes: true,
        attributeFilter: ['class']
      });
      
      window.__scrollToTopObserver = observer;
    }
  }
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }
  onReady(initGlobalScrollToTop);
  
  // Reinitialize on section load/unload for Shopify theme editor
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initGlobalScrollToTop, 0);
  });
  
  document.addEventListener('shopify:section:unload', function() {
    setTimeout(initGlobalScrollToTop, 0);
  });
})();
// Auto-expand Color filter on mobile when filters drawer opens
(function() {
  function isMobile() {
    return window.innerWidth < 768; // Adjust breakpoint as needed
  }
  function findColorFilter(container) {
    if (!container) return null;
    
    // Get all filter triggers
    var filterTriggers = container.querySelectorAll('[data-collapsible-trigger]');
    
    // Try to find Color filter by label text (case-insensitive)
    for (var i = 0; i < filterTriggers.length; i++) {
      var trigger = filterTriggers[i];
      var labelElement = trigger.querySelector('span');
      
      if (labelElement) {
        var labelText = labelElement.textContent.trim().toLowerCase();
        // Check for common color filter labels
        if (labelText.indexOf('color') !== -1 || 
            labelText.indexOf('colour') !== -1 ||
            labelText.indexOf('颜色') !== -1) {
          return trigger;
        }
      }
    }
    
    return null;
  }
  function expandColorFilter() {
    if (!isMobile()) return;
    
    // Find filters container
    var filtersContainer = document.querySelector('.collection__filters');
    if (!filtersContainer) return;
    
    // Check if filters drawer is visible
    if (!filtersContainer.classList.contains('collection__filters--visible')) {
      return;
    }
    
    // Find Color filter
    var colorFilter = findColorFilter(filtersContainer);
    if (!colorFilter) return;
    
    // Check if already expanded
    if (colorFilter.classList.contains('is-expanded')) {
      return;
    }
    
    // Expand Color filter
    setTimeout(function() {
      colorFilter.click();
    }, 100); // Small delay to ensure drawer animation completes
  }
  function initAutoExpandColorFilter() {
    // Find filters container
    var filtersContainer = document.querySelector('.collection__filters');
    if (!filtersContainer) return;
    
    // Observe filters container for class changes
    if (!window.__colorFilterObserver) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            var target = mutation.target;
            if (target.classList.contains('collection__filters--visible')) {
              expandColorFilter();
            }
          }
        });
      });
      
      observer.observe(filtersContainer, {
        attributes: true,
        attributeFilter: ['class']
      });
      
      window.__colorFilterObserver = observer;
    }
  }
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }
  onReady(function() {
    // Initialize on page load
    setTimeout(initAutoExpandColorFilter, 500);
    
    // Reinitialize on section load/unload for Shopify theme editor
    document.addEventListener('shopify:section:load', function() {
      setTimeout(initAutoExpandColorFilter, 500);
    });
  });
})();
